import * as httpUtil from "@/utils/httpUtil";

const interfaces: Array<Record<string, any>> = [
  {
    //desc: "分页查询社区用户列表",
    method: "post",
    name: "communitySearch",
    url: "/community/layout/search",
  },
  {
    //desc: "修改装修模块",
    method: "post",
    name: "communityAddContents",
    url: "/community/layout/addContents",
  },
  {
    //desc: 上架/下架诊室",
    method: "post",
    name: "getPlaceList",
    url: "/doctor/consultation/getPlaceList",
  },
  {
    //desc: "获取装修模块",
    method: "post",
    name: "communityGetContents",
    url: "/community/layout/getContents",
  },
  {
    //desc: "分页查找社区用户列表",
    method: "post",
    name: "pageFindCommunityUser",
    url: "/postbar/layout/pageFindCommunityUser",
  },
  {
    //desc: "分页查找话题列表for热议配置",
    method: "post",
    name: "pageFindForHotConfig",
    url: "/postbar/topic/pageFindForHotConfig",
  },
  {
    //desc: "贴吧装修提交(保存草稿)",
    method: "post",
    name: "layoutSubmit",
    url: "/community/layout/submit",
  },
  {
    //desc: "首页装修 擅长疾病",
    method: "post",
    name: "findDepartmentsLabel",
    url: "/community/findDepartmentsLabel",
  },
  {
    //desc: "首页装修",
    method: "post",
    name: "fitmentIndex",
    url: "/medicine/fitment/index",
  },
  {
    //desc: "保存社区装修",
    method: "post",
    name: "fitmentSaveModule",
    url: "/medicine/fitment/saveModule",
  },
  {
    //desc: "保存社区装修",
    method: "post",
    name: "pageArticleByTitle",
    url: "/medicine/article/pageArticleByTitle",
  },
  {
    //desc: "社区装修",
    method: "post",
    name: "toogleRelease",
    url: "/community/switchOnline",
  },
  {
    //desc: "分页列出个人的所有社区类型数量",
    method: "get",
    name: "pagePersonalCommunityCount",
    url: "/community/pagePersonalCommunityCount",
  },
  {
    //desc: "资质认证",
    method: "post",
    name: "updateAuditInfo",
    url: "/community/audit/updateAuditInfo",
  },
  {
    desc: "社区基本信息",
    method: "get",
    name: "findEditCommunityDetail",
    url: "/community/findEditCommunityDetail",
  },
  {
    method: "post",
    name: "communitySave",
    url: "/community/save", //创建社区
  },
  {
    method: "post",
    name: "shopDetailInfo",
    url: "/shop/detail", //零售商信息
  },
  {
    method: "post",
    name: "saveShopInfo",
    url: "/shop/save", //保存零售商信息
  },
  // 查询健康社区详情
  {
    method: "post",
    name: "getHcDetail",
    url: "/hc/detail",
  },
  // 查询健康社区审核
  {
    method: "post",
    name: "findHcAuditStatus",
    url: "/hc/findAuditStatus",
  },
  // 测试社区名称是否重复
  {
    method: "post",
    name: "checkCommunityName",
    url: "/hc/checkCommunityNameRepeat",
    config: { ignoreError: true },
  },
  // 更新健康社区审核
  {
    method: "post",
    name: "updateHcAuditInfo",
    url: "/hc/updateAuditInfo",
  },
  // 获取城镇信息
  {
    method: "get",
    name: "listTownByDistrictCode",
    url: "/district/listTownByDistrictCode",
  },
  {
    method: "post",
    name: "marketingTemplate",
    url: "/shop/marketingTemplate", //零售商模板信息
  },
  {
    method: "post",
    name: "getLastShopResponse",
    url: "/shop/getLastShopResponse",
  },
];

function exportsRender(interfacesArr: Array<Record<string, any>>) {
  const resultExports: Record<string, any> = {};
  interfacesArr.map((item: Record<string, any>) => {
    resultExports[item.name] = (data: Record<string | number, any>) => {
      return (httpUtil as Record<string, any>)[item.method](item.url, data);
    };
  });
  return resultExports;
}

export default exportsRender(interfaces);
